
$(document).ready(function () {

     jQuery('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        var target = jQuery(this).attr('href');
        var headerHeight = document.querySelector("header").offsetHeight;
        var targetPosition = jQuery(target).offset().top - headerHeight;

        jQuery('html, body').animate({ scrollTop: targetPosition }, 500);
    });


    /* ==== sticky header ==== */
$('#exampleModal').insertAfter('body');

    $(window).scroll(function () {
        let windowTop = $(window).scrollTop() + 1;
        if (windowTop > 30) {
            $('.header-menu').addClass('sticky-header');
        } else {
            $('.header-menu').removeClass('sticky-header');
        }
    });

    /* ==== Nav toggle ==== */
    $('.menu-button').click(function() {
        $('.mobileOverlay').toggleClass('toggle');
        $('.mobile_primary').toggleClass('active');
        $('.menu-button').toggleClass('toggle');
    });

    /* ==== Mobile nav ==== */
    var FX = function(a, b) {
        b(".mobile_primary .menu-item-has-children").append('<span class="sub-menu-button"></span>'),
        b(".sub-menu-button").each(function() {
            b(this).click(function() {
                b(this).toggleClass("open"),
                b(this).prev().slideToggle();
                $('.menu-item-has-children').removeClass('current-menu-item');
                b(this).parent().addClass('current-menu-item');
            });
        });
    }
        (FX || {}, jQuery);
    $('.mobileOverlay').click(function () {
        $('.mobileOverlay').toggleClass('toggle');
        $('.mobile_primary').toggleClass('active');
        $('.menu-button').toggleClass('toggle');
    });

    $('.menuClose').click(function () {
        $('.mobileOverlay').toggleClass('toggle');
        $('.mobile_primary').toggleClass('active');
        $('.menuClose').toggleClass('toggle');
        $('.menu-button').toggleClass('toggle');
    });

    /* ==== mobile nav end ==== */

    /* ==== Banner Slider ==== */
    $('#sliderBanner').owlCarousel({
        loop: false,
        autoplay: true,
        items: 1,
        margin: 10,
        nav: true,
        dots: true,
        responsive:{
            0:{
                items:1,
            },
            480:{
                items:1,
            },
            768:{
                items:1,
            },
            991:{
                items:1,
                loop: false
            },
            1024:{
                items:1,
                loop: true
            }
        }
    });

    $('#brandSlider').owlCarousel({
        loop: true,
        margin: 15,
        autoplay: false,
        nav: true,
        items: 2,
        dots: false,
        navText: [""],
        responsive:{
            0:{
                items: 1,
                margin: 15
            },
            480:{
                items: 1,
                margin: 15
            },
            768:{
                items: 1
            },
            992:{
                items:1,
                margin:55
            }
        }
    });    

    $('#directorSlider').owlCarousel({
        loop: true,
        margin:30,
        autoplay: true,
        nav: true,
        items: 3,
        dots: true,
        navText: ["<img src='assets/img/arrow-left.png'>","<img src='assets/img/arrow-right.png'>"],
        responsive:{
            0:{
                items:1,
                margin:10
            },
            480:{
                items: 1,
                margin:10
            },
            768:{
                items: 2,
                margin:10
            },
            992:{
                items: 3,
                margin:20
            }
        }
    });     
    
    $('#directorsSlider').owlCarousel({
        loop: true,
        margin: 40,
        autoplay: true,
        nav: true,
        items: 1,
        dots: false,
        navText: ["<img src='assets/img/arrow-left.png'>","<img src='assets/img/arrow-right.png'>"],
        responsive:{
            0:{
                items: 1,
                margin: 40
            },
            480:{
                items: 2,
                margin: 40
            },
            768:{
                items: 2,
                margin: 40
            },
            992:{
                items: 4,
                margin: 40
            }
        }
    });    
    
    $('#investorSlider').owlCarousel({
        loop: true,
        margin: 30,
        autoplay: false,
        nav: true,
        items: 4,
        dots: false,
        navText: ["<img src='assets/img/arrow-left.png'>","<img src='assets/img/arrow-right.png'>"],
        responsive:{
            0:{
                items: 2,
                margin: 30
            },
            480:{
                items: 2,
                margin: 30
            },
            768:{
                items: 3,
                margin: 30
            },
            992:{
                items: 4.2,
                margin: 30
            }
        }
    });  
    
    $('#guidelineSlider').owlCarousel({
        loop: true,
        margin: 50,
        autoplay: false,
        nav: true,
        items: 4,
        dots: false,
        navText: ["<img src='assets/img/arrow-left.png'>","<img src='assets/img/arrow-right.png'>"],
        responsive:{
            0:{
                items: 2,
                margin: 50
            },
            480:{
                items: 2,
                margin: 50
            },
            768:{
                items: 3,
                margin: 50
            },
            992:{
                items: 3.6,
                margin: 50
            }
        }
    });      
    
    $('#missionSlider').owlCarousel({
        loop: true,
        margin: 45,
        autoplay: false,
        nav: true,
        items: 4,
        dots: false,
        navText: ["<img src='assets/img/arrow-left.png'>","<img src='assets/img/arrow-right.png'>"],
        responsive:{
            0:{
                items: 2,
                margin: 45
            },
            480:{
                items: 2,
                margin: 45
            },
            768:{
                items: 2,
                margin: 45
            },
            992:{
                items: 2.7,
                margin: 45
            }
        }
    });    
    
    $('#goalSlider').owlCarousel({
        loop: true,
        margin: 15,
        autoplay: false,
        nav: true,
        items: 4,
        dots: false,
        navText: ["<img src='assets/img/arrow-left.png'>","<img src='assets/img/arrow-right.png'>"],
        responsive:{
            0:{
                items: 1,
                margin: 15,
                nav: false
            },
            480:{
                items: 1,
                margin: 15,
                nav: false
            },
            768:{
                items: 1,
                nav: false
            },
            992:{
                items: 1
            }
        }
    });
	
	
	    $('#journeySlider').owlCarousel({
        loop: true,
        margin: 15,
        autoplay: false,
        nav: true,
        items: 4,
        dots: false,
        navText: ["<img src='assets/img/arrow-left.png'>","<img src='assets/img/arrow-right.png'>"],
        responsive:{
            0:{
                items: 1,
                margin: 15,
                nav: false
            },
            480:{
                items: 1,
                margin: 15,
                nav: false
            },
            768:{
                items: 1,
                nav: false
            },
            992:{
                items: 4
            }
        }
    });
    
    
});


 
   


